import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BookContext = createContext(null);
export const useBooks = () => useContext(BookContext);

export function BookProvider({ children }) {
  const { user } = useAuth();
  const [books, setBooks] = useState([]);
  const [activeId, setActiveIdState] = useState(
    () => localStorage.getItem("jespay_active_book") || ""
  );
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/books");
      setBooks(data);
      const stored = localStorage.getItem("jespay_active_book") || "";
      if (!stored || !data.find((b) => b.id === stored)) {
        const def = data.find((b) => b.is_default) || data[0];
        if (def) {
          localStorage.setItem("jespay_active_book", def.id);
          setActiveIdState(def.id);
        }
      } else {
        setActiveIdState(stored);
      }
    } catch (err) {
      console.error("Failed to load books", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Reload when auth state flips to a logged-in user
  useEffect(() => {
    if (user && user !== false) {
      reload();
    } else if (user === false) {
      setBooks([]);
      setLoading(false);
    }
  }, [user, reload]);

  const setActive = (id) => {
    localStorage.setItem("jespay_active_book", id);
    setActiveIdState(id);
  };

  const activeBook = books.find((b) => b.id === activeId) || null;

  return (
    <BookContext.Provider
      value={{ books, activeId, activeBook, setActive, reload, loading }}
    >
      {children}
    </BookContext.Provider>
  );
}
